import { API_ENDPOINTS } from "./Constants";
import { apiFetch } from "./apiHelper";

export const ReservationService = {
    addReservation: async (idUser, idBook) => {
        try {
            const res = await apiFetch(API_ENDPOINTS.RESERVATION, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ idUser, idBook }),
                credentials: "include",
            });

            const data = await res.json().catch(() => ({}));

            if (res.ok) {
                return {
                    success: true,
                    message: data.message || "Rezervacija uspješno dodana.",
                };
            } else {
                return {
                    success: false,
                    message:
                        data.message || "Dogodila se greška prilikom rezervacije.",
                };
            }
        } catch (error) {
            return {
                success: false,
                message: "Greška u komunikaciji sa serverom.",
            };
        }
    },

    cancelReservation: async (idUser, idBook) => {
        try {
            const res = await apiFetch(API_ENDPOINTS.RESERVATION, {
                method: "DELETE",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ idUser, idBook }),
                credentials: "include",
            });

            const data = await res.json().catch(() => ({}));

            if (res.ok) {
                return {
                    success: true,
                    message: data.message || "Rezervacija uspješno otkazana.",
                };
            } else {
                return {
                    success: false,
                    message:
                        data.message || "Dogodila se greška prilikom otkazivanja rezervacije.",
                };
            }
        } catch (error) {
            return {
                success: false,
                message: "Greška u komunikaciji sa serverom.",
            };
        }
    },
};

export default ReservationService;
